let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("17b0i")).then(() => parcelRequire('6HAdB'));